module.exports = __webpack_public_path__ + "img/album14_17.9ca19585.jpg";